import { makeAutoObservable } from 'mobx';
import OrderService from '../services/orderService';

export class OrderKosaComponentsStore {
    loading = false;
    kosaComponents = []; // массив компонентов вида [{name, count}]

    constructor() {
        makeAutoObservable(this);
    }

    async load(orderId) {
        this.loading = true;
        try {
            const response = await OrderService.getKosasComponents(orderId);
            this.kosaComponents = Array.isArray(response.data) ? response.data : [];
        } catch (e) {
            throw new Error('Ошибка загрузки данных');
        } finally {
            this.loading = false;
        }
    }
}
